import {IFetchContext} from "@pg-mono/data-fetcher";
import {priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {IRootState} from "../../../store/store";
import {getRcnDataApi} from "../api/get_rcn_data_api";
import {getDefaultRoomsFilter, getRoomsFlatsLabelWhere} from "../constants/prices_address_rooms";
import {formatRcnPointPeriodWithPreposition} from "../utils/format_rcn_period_label";
import {getRcnLatestGrainQueries, pickRcnLatestPoint, toRcnGrainAnswer} from "../utils/resolve_rcn_latest_point";

const PRICES_ADDRESS_ROBOTS = "noindex, follow";

export const updatePricesAddressMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
    const state = getState();
    const address = state.report.price.address;
    const availableRooms = state.report.price.addressRooms;

    if (!address) {
        return false;
    }

    const rooms = getDefaultRoomsFilter(availableRooms);
    // The point the hero shows: the newest point of the grains fetchPricesAddressRcnData left in the cache.
    const resolved = pickRcnLatestPoint(
        getRcnLatestGrainQueries(address.rcnAddress, rooms).map((query) =>
            toRcnGrainAnswer(getRcnDataApi.endpoints.getRcnData.select(query)(state as IRootState))
        )
    );
    const latestPoint = resolved && resolved !== "pending" ? resolved.point : null;

    const title = concatWithBrandName(`${address.name}, ${address.city.short_name} - ceny transakcyjne mieszkań -`);

    const priceSentence = latestPoint
        ? ` Mediana ${getRoomsFlatsLabelWhere(rooms)} to ${priceM2Format(latestPoint.value, {precision: 0})} (dane ${formatRcnPointPeriodWithPreposition(latestPoint)}).`
        : "";

    const description = `Ile naprawdę płacono za mieszkania pod adresem ${address.name} ${address.city.name_declension_where}? Ceny z aktów notarialnych dla tego budynku, porównanie z dzielnicą i miastem oraz trend cen.${priceSentence}`;

    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, robots: PRICES_ADDRESS_ROBOTS}));

    return true;
};
import {IFetchContext} from "@pg-mono/data-fetcher";
import {priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {concatWithBrandName} from "../../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {IRootState} from "../../../store/store";
import {getRcnDataApi} from "../api/get_rcn_data_api";
import {getDefaultRoomsFilter, getRoomsFlatsLabelWhere} from "../constants/prices_address_rooms";
import {formatRcnPointPeriodWithPreposition} from "../utils/format_rcn_period_label";
import {getRcnLatestGrainQueries, pickRcnLatestPoint, toRcnGrainAnswer} from "../utils/resolve_rcn_latest_point";

const PRICES_ADDRESS_ROBOTS = "noindex, follow";

export const updatePricesAddressMetaData = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
    const state = getState();
    const address = state.report.price.address;
    const availableRooms = state.report.price.addressRooms;

    if (!address) {
        return false;
    }

    const rooms = getDefaultRoomsFilter(availableRooms);
    // The point the hero shows: the newest point of the grains fetchPricesAddressRcnData left in the cache.
    const resolved = pickRcnLatestPoint(
        getRcnLatestGrainQueries(address.rcnAddress, rooms).map((query) =>
            toRcnGrainAnswer(getRcnDataApi.endpoints.getRcnData.select(query)(state as IRootState))
        )
    );
    const latestPoint = resolved && resolved !== "pending" ? resolved.point : null;

    const title = concatWithBrandName(`${address.name}, ${address.city.short_name} - ceny transakcyjne mieszkań -`);

    const priceSentence = latestPoint
        ? ` Mediana ${getRoomsFlatsLabelWhere(rooms)} to ${priceM2Format(latestPoint.value, {precision: 0})} (dane ${formatRcnPointPeriodWithPreposition(latestPoint)}).`
        : "";

    const description = `Ile naprawdę płacono za mieszkania pod adresem ${address.name} ${address.city.name_declension_where}? Ceny z aktów notarialnych dla tego budynku, porównanie z dzielnicą i miastem oraz trend cen.${priceSentence}`;

    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname, robots: PRICES_ADDRESS_ROBOTS}));

    return true;
};
